const target = document.querySelector('#quiz_wrap');

if (target) {
  let lastProductLabel = null;
  const TOTAL_STEPS = 4;
  let currentStep = 1;
  let lastStepText = null;

  function renderProgressBeforeTitle() {
    const containers = Array.from(document.querySelectorAll('#quiz_wrap .scrollable-content.large'));
    const container = containers.find(el => el.querySelector('h1 strong') || el.querySelector('h1'));
    if (!container) return;

    const titleStrong = container.querySelector('h1 strong');
    const titleH1 = titleStrong?.closest('h1') || container.querySelector('h1');

    container.querySelector('.quiz-progress')?.remove();

    const progress = document.createElement('div');
    progress.className = 'quiz-progress';
    progress.innerHTML = `
      <div class="quiz-progress-track">
        <div class="quiz-progress-bar"></div>
      </div>
      <div class="quiz-progress-text quiz-progress-${currentStep}">
        <span class="current">${currentStep}</span> of <span class="total">${TOTAL_STEPS}</span>
      </div>
    `;

    if (window.matchMedia('(max-width: 750px)').matches) {
      container.prepend(progress);
    } else {
      if (titleH1) titleH1.before(progress);
      else container.prepend(progress);
    }

    updateProgress(currentStep);
  }

  window.addEventListener('resize', renderProgressBeforeTitle);

  function updateProgress(step) {
    const progress = document.querySelector('.quiz-progress');
    if (!progress) return;

    const bar = progress.querySelector('.quiz-progress-bar');
    const currentText = progress.querySelector('.current');
    const totalText = progress.querySelector('.total');

    const percent = Math.min((step / TOTAL_STEPS) * 100, 100);

    bar.style.width = percent + '%';
    currentText.textContent = step;
    totalText.textContent = TOTAL_STEPS;
  }


  updateProgress(1);

  const priceCache = {};

  function extractProductName(label) {
    return label.replace('product row', '').trim();
  }

  function fetchProductPrice(handle) {
    if (priceCache[handle]) return Promise.resolve(priceCache[handle]);
    return fetch(`/products/${handle}.js`)
      .then(r => r.json())
      .then(p => {
        const v = p.variants.find(v => v.available) || p.variants[0];
        const data = { price: v.price, compare: v.compare_at_price };
        priceCache[handle] = data;
        return data;
      });
  }

  function injectComparePrice() {
    $('#quiz_wrap .column-wrapper.product-item[aria-label]').each(function () {
      const label = $(this).attr('aria-label');
      if (!label) return;
      const name = extractProductName(label);
      fetch(`/search/suggest.json?q=${encodeURIComponent(name)}&resources[type]=product`)
        .then(r => r.json())
        .then(d => {
          const product = d.resources?.results?.products?.[0];
          if (!product) return;
          return fetchProductPrice(product.handle);
        })
        .then(priceData => {
          if (!priceData || !priceData.compare || priceData.compare <= priceData.price) return;
          $(this)
            .closest('.product-catalog-column')
            .find('.price .text, .product-price .text, .price-wrapper .text')
            .each(function () {
              if ($(this).find('.compare-price').length) return;
              $(this).append(
                `<span class="compare-price" style="text-decoration:line-through; color:#B1B1B1; margin-left:10px;">
                  $${(priceData.compare / 100).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}
                </span>`
              );
            });
        });
    });
  }

  const productObserver = new MutationObserver(mutations => {
    mutations.forEach(m => {
      if (m.type === 'attributes' && m.attributeName === 'aria-label') {
        const label = m.target.getAttribute('aria-label');
        if (label !== lastProductLabel) {
          lastProductLabel = label;
          createAgainButton();
          createSlideArrow();
          slideHeightResize();
          injectComparePrice();
        }
      }
    });
  });

  const observer = new MutationObserver(() => {
    const targetEl = document.querySelector(
      '#quiz_wrap .scrollable-content.large .form-field-wrapper.form-field-wrapper-button'
    );
    const targetResult = document.querySelector(
      '#quiz_wrap .scrollable-content.small .form-field-wrapper.underlined-input'
    );
    const targetResultFin = document.querySelector(
      '#quiz_wrap .scrollable-content.small .product-catalog-wrapper'
    );
    const targetResultText = document.querySelector(
      '#quiz_wrap .scrollable-content.small .product-catalog-wrapper .price-wrapper'
    );

    if (targetEl) {
      $('.quiz-progress').show();
    } else {
      $('.quiz-progress').hide();
    }

    if (targetEl && !targetEl.dataset.scriptAdded) {
      targetEl.dataset.scriptAdded = 'true';
      $(targetEl).find('.basic-button').before('<div class="back_button">Back</div>');
      $('button[aria-label="Back"]').hide();
      $('.back_button').off('click').on('click', () => {
        $('button[aria-label="Back"]').trigger('click');
      });
    }

    if (targetResult && !targetResult.dataset.scriptAdded) {
      targetResult.dataset.scriptAdded = 'true';
      $('#quiz_wrap .scrollable-content.small').addClass('result');
      $('#quiz_wrap .scrollable-content.small .form-field-wrapper.form-field-wrapper-button')
        .find('.basic-button')
        .after('<div class="skip_button">Skip</div>');
      $('.secondary-button-wrapper').hide();
      $('.skip_button').off('click').on('click', () => {
        $('button[aria-label*="Skip"]').trigger('click');
      });
    }

    if (targetResultFin) {
      updateProgress(TOTAL_STEPS);
      $('.quiz-progress').hide();

      const productItem = document.querySelector('#quiz_wrap .column-wrapper.product-item[aria-label]');
      if (productItem && !productItem.dataset.observing) {
        productItem.dataset.observing = 'true';
        lastProductLabel = productItem.getAttribute('aria-label');
        productObserver.observe(productItem, { attributes: true, attributeFilter: ['aria-label'] });
        createAgainButton();
        createSlideArrow();
        injectComparePrice();
      }
    }

    if (targetResultText){
        slideHeightResize();
    }

    if (targetEl) {
      requestAnimationFrame(() => {
        const stepEl = document.querySelector('#quiz_wrap .scrollable-content.large h1 strong');
        if (!stepEl) return;

        const text = stepEl.textContent.trim();
        if (text === lastStepText) return;

        const match = text.match(/\d+/);
        if (!match) return;

        lastStepText = text;
        currentStep = Math.min(parseInt(match[0], 10), TOTAL_STEPS);
        updateProgress(currentStep);
        renderProgressBeforeTitle();
      });
    }
  });

  observer.observe(target, { childList: true, subtree: true });

  function createAgainButton() {
    $('.again_button').remove();
    $('#quiz_wrap .scrollable-content.small .button-wrapper').each(function () {
      $(this).find('.basic-button').before('<div class="again_button">Take Quiz Again</div>');
    });
    $('button[aria-label="Back"]').hide();
    $('.again_button').off('click').on('click', () => {
      window.location.reload();
    });
  }

  function createSlideArrow() {
    $('.slide_arrow').remove();
    $('#quiz_wrap .scrollable-content.small .column-wrapper.product-item').each(function(){

      if($(this).find('.product-carousel-dot-navigation .dot').length > 1){
        $(this).append('<div class="slide_arrow"><div class="prev_slide"></div><div class="next_slide"></div></div>');
      }    
    })
  } 

  function slideHeightResize() {    
    $('#quiz_wrap .scrollable-content.small .column-wrapper.product-item').each(function(){
      if($(this).find('.price-wrapper').outerHeight() > 1){
        const slideSize = 100 - ($(this).find('.price-wrapper').outerHeight() + $(this).find('.title-wrapper .text div').outerHeight() + 8);
        console.log($(this).find('.price-wrapper').outerHeight(), $(this).find('.title-wrapper .text div').outerHeight())
        if(slideSize < 92){
          $(this).find('.price-wrapper').find('.text').attr('style','margin-bottom:'+slideSize+'px !important');
        }
      }    
    })  
  }
        
  $(document).on('click', '.slide_arrow .prev_slide, .slide_arrow .next_slide', function () {
    $('.dot.inactive').first().trigger('click');
  });

}
